import { JOINER_INFO } from '../constant';

export const updateJoinerInfo = data => ({type:JOINER_INFO, data})


